import request from '@/utils/request'

export function getWxAppInfo(appCode) {
  return request({
    url: `/api/manage/open/app/wxapp/${appCode}`,
    method: 'post',
  })
}

export function getAppAttributeList(params) {
  return request({
    url: `/api/manage/open/app/attributes`,
    method: 'get',
    params,
  })
}

export function getMiniAppList(params) {
  return request({
    url: `/api/manage/open/app/miniapp/list`,
    method: 'get',
    params,
  })
}


export default {
  getWxAppInfo,
  getAppAttributeList,
  getMiniAppList
}
